module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d5uVY"))).then(() => parcelRequire('d0iPb'));